import {createSvgIcon} from '../create-svg-icon';

export const FourGPlusMobiledataIcon = createSvgIcon(
  <path d="M13 11v2h2v2h-4V9h6c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-4h-4zm11 0h-2V9h-2v2h-2v2h2v2h2v-2h2v-2zM7 7H5v5H3V7H1v7h4v3h2v-3h1v-2H7V7z" />
, 'FourGPlusMobiledataOutlined');
